import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import SvgIcon from '../SvgIcon.js';
var IconIcWidgetBlack = props => /*#__PURE__*/
// eslint-disable-next-line react/jsx-props-no-spreading
React.createElement(SvgIcon, _extends({}, props, {
  viewBox: "0 0 66 66",
  iconname: "IconIcWidgetBlack"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#pathTo_Svg__Filter0_D_16473_133415)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55.9858 29.3906C55.8421 38.4751 50.263 46.1711 42.457 49.7857C39.3801 51.21 36.0039 52 32.4482 52H10V29.5582C10 24.8424 11.4247 20.3421 13.9389 16.5838C17.8299 10.6712 24.271 6.52991 31.5742 6.05115C31.9333 6.02721 32.2686 6.00328 32.6277 6.00328C41.2119 5.85965 48.7425 10.4438 52.8012 17.302C54.9083 20.8328 56.0576 24.9741 55.9978 29.3906H55.9858Z",
  fill: "#323232"
})), /*#__PURE__*/React.createElement("path", {
  d: "M41.3525 29C41.2216 29.9981 41.0252 30.9934 40.8226 31.9819C40.7566 32.3038 40.6841 32.6277 40.5936 32.9452C40.4138 33.575 40.1449 34.1847 39.7809 34.7497C39.2835 35.5219 38.7804 36.1902 38.1222 36.8638C37.578 37.4208 36.9964 37.9276 36.2758 38.307C35.4922 38.7196 34.5931 39.1737 33.7536 39.4902C33.065 39.7497 32.3323 39.9164 31.5826 39.954C31.1741 39.9744 30.7611 40 30.3525 40",
  stroke: "#FFC814",
  strokeWidth: "3",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("rect", {
  x: "25",
  y: "22.0156",
  width: "3.24965",
  height: "10.0594",
  rx: "1.62483",
  transform: "rotate(-3.87644 25 22.0156)",
  fill: "#FF3296"
}), /*#__PURE__*/React.createElement("rect", {
  x: "31.5557",
  y: "21.2188",
  width: "3.24965",
  height: "10.0594",
  rx: "1.62483",
  transform: "rotate(-3.87644 31.5557 21.2188)",
  fill: "#0096FF"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "pathTo_Svg__Filter0_D_16473_133415",
  x: "0",
  y: "0",
  width: "66",
  height: "66",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "4"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "5"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_DropShadow_16473_133415"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_DropShadow_16473_133415",
  result: "shape"
}))));
export { IconIcWidgetBlack as default };
//# sourceMappingURL=IconIcWidgetBlack.js.map